import _ from 'lodash';
import ConfigService from '@/services/config.service';
import TranslateService from '@/services/translate.service';

/*

configuration: {
  authType: "" // DEMO / KERBEROS
  features: ["offers", "feature1", "feature2", ...],
  userInfo: {
    loggedIn: boolean,
    userName: "",
    roles: []
  },
  productionSearchFields: [{}],
  licenceSearchFields: [{}],
  tableConfiguration: {
    MultiAvailGrid: {
      fixedFields: [],
      dynamicFields: []
    }
  }

}

 */


const state = {
  configuration: {},
  features: new Set(),
  authType: "",
  userInfo: {},
  productionSearchFields: [],
  licenceSearchFields: [],
  tableConfiguration: {},
  configurationLoaded: false
}

const mutations = {
  setFeatures(state, features) {
    _.forEach(features, (feature) => {
      state.features.add(feature);
    })
    state.features = _.cloneDeep(state.features);
  },
  setAuthType(state, authType) {
    state.authType = authType;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = _.cloneDeep(userInfo);
  },
  setConfiguration(state, configuration) {
    state.configuration = _.cloneDeep(configuration);

    if (_.has(configuration, "productionSearchFields")) {
      state.productionSearchFields = _.get(configuration, "productionSearchFields");
    }

    if (_.has(configuration, "licenceSearchFields")) {
      state.licenceSearchFields = _.get(configuration, "licenceSearchFields");
    }

    if (_.has(configuration, "tableConfiguration")) {
      state.tableConfiguration = _.get(configuration, "tableConfiguration");
    }


    state.configurationLoaded = true;
  }
}

const getters = {
  configurationLoaded: (state) => {
    return state.configurationLoaded;
  },
  authType: (state) => {
    return state.authType;
  },
  userInfo: (state) => {
    return _.cloneDeep(state.userInfo);
  },
  featureActive: (state) => (feature) => {
    return state.features.has(feature);
  },
  isAdmin: (state) => {
    let roles = _.get(state, "userInfo.roles", []);
    return roles.includes("ROLE_WEBAVAIL_ADMIN");
  },
  productionSearchFields: (state) => {
    return _.cloneDeep(state.productionSearchFields);
  },
  licenceSearchFields: (state) => {
    return _.cloneDeep(state.licenceSearchFields);
  },
  tableConfiguration: (state) => (tableName) => {
    if (_.has(state.tableConfiguration, tableName + ".dynamicFields")) {

      let resultFields = [];
      _.forEach(_.get(state.tableConfiguration, tableName + ".dynamicFields"), (field) => {
        resultFields.push({
          field: field.fieldName,
          header: field.fieldLabel,
          headerStyle: "width: 150px",
          isDropDownFilter: field.dropDownFilter,
          isTextFilter: field.textFilter,
          searchFieldType: field.searchFieldType,
          displayType: _.get(field, 'displayType', 'DEFAULT')

        })
      });


      resultFields.push(
        {
          field: "globalTrafficLight",
          header: "Overall",
          headerStyle: "width: 150px",
          isDropDownFilter: true,
          isTextFilter: false,
          displayType: 'TRAFFIC_LIGHT',
          searchFieldType: "GLOBAL_TRAFFIC_LIGHT",

          // getter: gridhelper.renderTrafficLight
        }
      )


      return resultFields;
    } else {
      return [];
    }
  }
}

const actions = {
  loadConfiguration(context) {
    return new Promise((resolve, reject) => {
      ConfigService.loadConfiguration().then((config) => {
        context.commit("setConfiguration", config.data);
        context.commit("setAuthType", _.get(config, "data.authType", "ERROR"));
        context.commit("setFeatures", _.get(config, "data.features", []));
        context.commit("setUserInfo", _.get(config, "data.userInfo", {}));

        TranslateService.addToMessageSource(_.get(config, "data.messages", {}));

        resolve();
      }).catch(() => {
        reject();
      })
    });
  },
  loadPublicConfiguration(context) {
    return new Promise((resolve, reject) => {
      ConfigService.loadPublicConfiguration().then((config) => {
        context.commit("setConfiguration", config.data);
        context.commit("setAuthType", _.get(config, "data.authType", "ERROR"));
        context.commit("setFeatures", _.get(config, "data.features", []));
        context.commit("setUserInfo", _.get(config, "data.userInfo", {}));

        TranslateService.addToMessageSource(_.get(config, "data.messages", {}));

        resolve();
      }).catch(() => {
        reject();
      })
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
